export default __webpack_public_path__ + "static/media/Raleway-Bold.18960343.ttf";